import api from '@utils/api';
import FocusTrap from 'focus-trap-react';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SwiperCore, { Autoplay, Keyboard, Mousewheel } from 'swiper';
import { Swiper as SwiperInstance, SwiperSlide } from 'swiper/react';
import AutoplayCarousel from '../autoplayCarousel/AutoplayCarousel';
import CuratorCarouselSlide from './CuratorCarouselSlide';
import CuratorCarouselSlideZoomModal from './CuratorCarouselSlideZoomModal';
SwiperCore.use([Keyboard, Autoplay, Mousewheel]);
const timing = 10000;
const CuratorCarousel = (props) => {
    const { t } = useTranslation();
    const btnLeft = useRef();
    const btnRight = useRef();
    const [disabled, setDisabled] = useState(false);
    const [sliderComponent, setSliderComponent] = useState();
    const [slides, setSlides] = useState();
    const [modalOpen, setModalOpen] = useState(false);
    const [currentZoomSlide, setCurrentZoomSlide] = useState(0);
    const swiperConf = {
        keyboard: { enabled: true },
        speed: timing,
        watchSlidesProgress: true,
        loop: true,
        centeredSlides: true,
        slidesPerView: 1.8,
        spaceBetween: 24,
        autoplay: {
            delay: 0,
            disableOnInteraction: false,
        },
        mousewheel: {
            forceToAxis: true,
            thresholdDelta: 20,
        },
        a11y: {
            slideLabelMessage: '',
        },
        breakpoints: {
            400: {
                slidesPerView: 1.8,
                spaceBetween: 24,
            },
            600: {
                slidesPerView: 3.2,
                spaceBetween: 65,
            },
            1024: {
                slidesPerView: 2.8,
                spaceBetween: 80,
            },
            1200: {
                slidesPerView: 3.2,
                spaceBetween: 120,
            },
        },
    };
    useEffect(() => {
        api.getPageJson(props.pageId, true).then((data) => {
            const carouselComponent = data === null || data === void 0 ? void 0 : data.regions[0].components.find((el) => el.id === props.uuid);
            setSliderComponent(carouselComponent.data);
            setSlides(carouselComponent.regions[0].components);
        });
    }, []);
    const closeModal = () => {
        setModalOpen(false);
        document.querySelector('body').classList.remove('modal-carousel-curator-open');
    };
    const openModal = (slideIndex) => {
        setModalOpen(true);
        document.querySelector('body').classList.add('modal-carousel-curator-open');
        setCurrentZoomSlide(slideIndex);
    };
    const controls = (pauseButton) => {
        return (React.createElement("div", { className: "row curator-carousel-arrow-row" },
            React.createElement("div", { className: "col-3" }, pauseButton),
            React.createElement("div", { className: "curator-carousel__arrow-container col-6" },
                React.createElement("i", { className: "btn--backward-white" }),
                React.createElement("p", { className: "curator-carousel__arrow-txt" }, t('button.dragtoexplore')),
                React.createElement("i", { className: "btn--forward-white" })),
            React.createElement("div", { className: "curator-carousel__arrow-container col-3" })));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("h2", { className: "curator-carousel__title" }, sliderComponent === null || sliderComponent === void 0 ? void 0 : sliderComponent.title),
        React.createElement("div", { className: "curator-carousel__swiper-container js-curator-carousel", "data-option-title": sliderComponent === null || sliderComponent === void 0 ? void 0 : sliderComponent.title },
            React.createElement("div", { className: "curator-carousel__description col-sm-6", dangerouslySetInnerHTML: { __html: sliderComponent === null || sliderComponent === void 0 ? void 0 : sliderComponent.text } }),
            React.createElement("div", { className: "curator-carousel__carousel-wrapper" },
                React.createElement(AutoplayCarousel, { swiperConf: swiperConf, afterContainer: controls, darkMode: true }, slides === null || slides === void 0 ? void 0 : slides.map((slide, i) => (React.createElement(SwiperSlide, { key: slide.id, onClick: () => openModal(i) },
                    React.createElement(CuratorCarouselSlide, { url: slide.custom.image, alt: slide.data.imgAlt, current: i + 1, max: slides.length }))))))),
        modalOpen && (React.createElement(FocusTrap, null,
            React.createElement("div", { className: "swiper-container swiper-container--gallery focus-inverted curator-carousel__zoom-container js-curator-carousel__zoom", role: "dialog", "aria-label": "Large view Gallery", tabIndex: -1 },
                React.createElement(SwiperInstance, { className: "curator-carousel-fullHeight", loop: true, keyboard: { enabled: true }, allowTouchMove: false, slidesPerView: 1, initialSlide: currentZoomSlide, navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    }, mousewheel: {
                        forceToAxis: true,
                        thresholdDelta: 20,
                    } }, slides === null || slides === void 0 ? void 0 :
                    slides.map((slide, i) => (React.createElement(SwiperSlide, { key: slide.id },
                        React.createElement(CuratorCarouselSlideZoomModal, { onZoom: setDisabled, url: slide.custom.image, slideText: slide.data.text, onCloseModal: () => closeModal(), alt: "{slide.data.imgAlt}", current: i + 1, max: slides.length })))),
                    React.createElement("div", { className: "carousel-gallery__arrow-container " },
                        React.createElement("button", { className: "carousel-gallery__arrow swiper-button-prev", "aria-label": t('carousel.prevslidemessage'), disabled: disabled, ref: btnLeft }),
                        React.createElement("button", { className: "carousel-gallery__arrow carousel-gallery__arrow--arrow-right swiper-button-next", "aria-label": t('carousel.nextslidemessage'), disabled: disabled, ref: btnRight }))))))));
};
export default CuratorCarousel;
